import { useEffect, useState } from 'react';
import BOLayout from '@/pages/back-office/BOLayout';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';

const VatEdition = () => {
	const [canSubmit, setCanSubmit] = useState(false);
	const [vat, setVat] = useState(null);
	const [name, setName] = useState('');
	const [productType, setProductType] = useState('');
	const [rate, setRate] = useState(0);
	const navigate = useNavigate();
	const { vatId } = useParams();
	const role = JSON.parse(localStorage.getItem('role'));

	useEffect(() => {
		if (role && role !== 'super-admin') {
			toast.info('Zone interdite', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

			navigate('/back-office');

			return;
		}
	}, [role]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/back-office/settings/vats/${vatId}/view`);

				if (response.status === 200) {
					setVat(response.data);
					setName(response.data.name);
					setProductType(response.data.product_type);
					setRate(response.data.rate);
				}
			} catch (error) {
				console.error('Error fetching vat:', error);
			}
		};

		fetchData();
	}, []);

	useEffect(() => {
		if (name) {
			setCanSubmit(true);
			return;
		}

		setCanSubmit(false);
	}, [name]);

	const handleSubmit = async (e) => {
		e.preventDefault();

		const formData = new FormData();
		formData.append('name', name);
		formData.append('product_type', productType);
		formData.append('rate', rate);

		try {
			const response = await axios.put(
				`${import.meta.env.VITE_API_URL}/api/back-office/settings/vats/${vatId}/update`,
				formData
			);

			if (response.status === 200) {
				toast.success('TVA modifiée avec succès', {
					position: 'top-center',
					autoClose: 800,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
				});
			}
		} catch (error) {
			console.error('Error editing vat:', error);

			toast.error('Une erreur est survenue', {
				position: 'top-center',
				autoClose: 800,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});
		}

		setTimeout(() => {
			navigate('/back-office/settings/tva/list');
		}, 1000);
	};

	return (
		<BOLayout>
			<div className="mb-12 grid grid-cols-1 gap-12">
				<SettingsTopBanner />
				<h1 className="text-3xl font-bold text-center">Modifiez la tva</h1>
			</div>

			<form className="text-center">
				<div className="xl:flex  justify-center items-center gap-2">
					<div className="flex flex-col">
						<label htmlFor="name" className="text-left pl-2">
							Nom
						</label>
						<input
							type="text"
							name="name"
							id="name"
							className="mb-4 border border-black p-2 rounded-lg"
							value={name}
							onChange={(e) => setName(e.target.value)}
						/>
					</div>

					<div className="flex flex-col">
						<label htmlFor="product_type" className="text-left pl-2">
							Type de produit
						</label>
						<input
							type="text"
							name="product_type"
							id="product_type"
							className="mb-4 border border-black p-2 rounded-lg"
							value={productType}
							onChange={(e) => setProductType(e.target.value)}
						/>
					</div>

					<div className="flex flex-col">
						<label htmlFor="rate" className="text-left pl-2">
							Taux en %
						</label>
						<input
							type="number"
							step={0.01}
							name="rate"
							id="rate"
							className="mb-4 border border-black p-2 rounded-lg"
							value={rate}
							onChange={(e) => setRate(e.target.value)}
						/>
					</div>
				</div>

				<button
					type="submit"
					onClick={handleSubmit}
					className={`transition duration-300 text-white px-4 py-2 rounded-lg ${canSubmit
							? 'bg-primary hover:bg-primary/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary/70'
							: 'bg-gray-400 cursor-not-allowed'
						}`}
					disabled={!canSubmit}
				>
					Modifier la tva
				</button>
			</form>
		</BOLayout>
	);
};

export default VatEdition;
